var map = {
	"./fonts/Roboto-Black.ttf": 6325,
	"./fonts/Roboto-BlackItalic.ttf": 2262,
	"./fonts/Roboto-Bold.ttf": 8933,
	"./fonts/Roboto-BoldItalic.ttf": 5278,
	"./fonts/Roboto-Italic.ttf": 896,
	"./fonts/Roboto-Light.ttf": 8652,
	"./fonts/Roboto-LightItalic.ttf": 6036,
	"./fonts/Roboto-Medium.ttf": 2577,
	"./fonts/Roboto-MediumItalic.ttf": 1251,
	"./fonts/Roboto-Regular.ttf": 6861,
	"./fonts/Roboto-Thin.ttf": 9605,
	"./fonts/Roboto-ThinItalic.ttf": 6980,
	"./icons/accommodation-variant-place.svg": 547,
	"./icons/accommodation-variant-square.png": 1232,
	"./icons/cross.svg": 7093,
	"./img/accommodation-quick-view/img-1.png": 291,
	"./img/accommodation-quick-view/img-2.png": 9038,
	"./img/accommodationVariant/img_2.jpg": 4395,
	"./img/bonusProgramsLogo/mir.png": 9479,
	"./img/bonusProgramsLogo/uds.png": 2183,
	"./img/categories-status/almaz.svg": 2539,
	"./img/categories-status/ametist-izumrud.svg": 9775,
	"./img/categories-status/ametist-yashma.svg": 9830,
	"./img/categories-status/ametist.svg": 6288,
	"./img/categories-status/corall.svg": 5952,
	"./img/categories-status/eko-house.svg": 4220,
	"./img/categories-status/granat.svg": 9413,
	"./img/categories-status/izumrud-saphir.svg": 9933,
	"./img/categories-status/izumrud.svg": 2735,
	"./img/categories-status/kotedj.svg": 9936,
	"./img/categories-status/rubin-izumrud.png": 1509,
	"./img/categories-status/rubin.svg": 1306,
	"./img/categories-status/saphir-ametist.svg": 8111,
	"./img/categories-status/saphir-rubin-izumrud-yashma.svg": 8078,
	"./img/categories-status/saphir-yashma.svg": 9030,
	"./img/categories-status/saphir.svg": 8417,
	"./img/categories-status/yashma.svg": 9771,
	"./img/category-features/bath.svg": 8233,
	"./img/category-features/bed-single.svg": 6245,
	"./img/category-features/big-bed.svg": 3443,
	"./img/category-features/closet.svg": 801,
	"./img/category-features/conditioner.svg": 7306,
	"./img/category-features/fridge.png": 4927,
	"./img/category-features/fridge.svg": 3163,
	"./img/category-features/jacuzzi.svg": 835,
	"./img/category-features/kettle.png": 1735,
	"./img/category-features/kettle.svg": 4436,
	"./img/category-features/kitchen.svg": 4885,
	"./img/category-features/oven.svg": 2675,
	"./img/category-features/phone.png": 9835,
	"./img/category-features/phone.svg": 4519,
	"./img/category-features/radio.png": 7152,
	"./img/category-features/radio.svg": 2779,
	"./img/category-features/room-feature-icon-4.png": 3264,
	"./img/category-features/room-feature-icon-8.png": 7117,
	"./img/category-features/sauna.svg": 369,
	"./img/category-features/shower.svg": 8784,
	"./img/category-features/sofa.svg": 2265,
	"./img/category-features/tv.png": 414,
	"./img/category-features/tv.svg": 6336,
	"./img/category-features/wifi.png": 2067,
	"./img/category-features/wifi.svg": 8606,
	"./img/category-features/солнце.svg": 7238,
	"./img/category-features/холодос.svg": 5915,
	"./img/empty-variants-bg.png": 6156,
	"./img/misc/fail-pic.png": 6203,
	"./img/misc/gift-icon.svg": 8356,
	"./img/misc/gift-pic.svg": 5923,
	"./img/misc/gift-success-pic.svg": 6570,
	"./img/misc/success-pic-bg-empty-green.svg": 6533,
	"./img/misc/success-pic-bg-empty.svg": 7837,
	"./img/misc/success-pic.svg": 8584,
	"./img/payment-method/2_pokupay_button_credit_color_alt.png": 3056,
	"./img/payment-method/2_pokupay_button_rass_color_alt.png": 7792,
	"./img/payment-method/icon-cards.png": 8982,
	"./img/payment-method/icon-sbp.png": 2717,
	"./img/payment-method/icon.svg": 6836,
	"./img/payment-method/ukassa-logo.svg": 7374,
	"./img/room-statuses/status-almaz.png": 7057,
	"./img/room-statuses/status-granat.png": 595,
	"./img/room-statuses/status-icon-1.png": 3510,
	"./img/room-statuses/status-izumrud.png": 5599,
	"./img/room-statuses/status-rubin.png": 1020,
	"./img/room-statuses/status-saphir.png": 4577,
	"./img/room-statuses/status-yashma.png": 8917,
	"./logo.png": 6949,
	"./logo.svg": 9574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;